export default {
    topics: [
        {
            title: ' isId ',
            href: 'p-DOMAttr-isId.html',
            attributes: { 'data-id': 'p-DOMAttr-isId' },
            menu: { hasChildren: false },
            tocID: 'p-DOMAttr-isId-d66e7451',
            topics: [],
        },
        {
            title: ' name ',
            href: 'p-DOMAttr-name.html',
            attributes: { 'data-id': 'p-DOMAttr-name' },
            menu: { hasChildren: false },
            tocID: 'p-DOMAttr-name-d66e7459',
            topics: [],
        },
        {
            title: ' ownerElement ',
            href: 'p-DOMAttr-ownerElement.html',
            attributes: { 'data-id': 'p-DOMAttr-ownerElement' },
            menu: { hasChildren: false },
            tocID: 'p-DOMAttr-ownerElement-d66e7467',
            topics: [],
        },
        {
            title: ' specified ',
            href: 'p-DOMAttr-specified.html',
            attributes: { 'data-id': 'p-DOMAttr-specified' },
            menu: { hasChildren: false },
            tocID: 'p-DOMAttr-specified-d66e7475',
            topics: [],
        },
        {
            title: ' value ',
            href: 'p-DOMAttr-value.html',
            attributes: { 'data-id': 'p-DOMAttr-value' },
            menu: { hasChildren: false },
            tocID: 'p-DOMAttr-value-d66e7483',
            topics: [],
        },
    ],
};

